import * as React from "react";
import { forwardRef } from "react";
const SvgCorner = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 6, height: 6, viewBox: "0 0 6 6", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0 6L6 0V6H0Z", fill: "#0F172A" }));
const ForwardRef = forwardRef(SvgCorner);
export { ForwardRef as ReactComponent };
